var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTipLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.032,
    height: 11.11,
    viewBox: "0 0 9.032 11.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#005699;stroke:#005699;stroke-width:0.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.185 0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.68,15.112h-2.2a1.031,1.031,0,0,1-1.031-1.031v-.825a1.7,1.7,0,0,0-.619-1.328,4.33,4.33,0,1,1,5.5,0,1.672,1.672,0,0,0-.619,1.328v.825A1.031,1.031,0,0,1,13.68,15.112Zm-2.818-1.65v.619a.619.619,0,0,0,.619.619h2.2a.619.619,0,0,0,.619-.619v-.619Zm0-.412h3.445a2.079,2.079,0,0,1,.748-1.443,3.9,3.9,0,0,0,1.438-3.2,3.909,3.909,0,1,0-6.387,3.2,2.1,2.1,0,0,1,.748,1.443Z",
    transform: "translate(-8.249 -4.252)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipLightBulb);
export default __webpack_public_path__ + "static/media/tip_light_bulb.ac493bcd81fbd6db1ee161d358c56d17.svg";
export { ForwardRef as ReactComponent };